// export const codigoPaises = [
//     {
//         nombre: 'AALAND ISLANDS',
//         codigo: 'AX'
//     },
//     {
//         nombre: 'AFGHANISTAN',
//         codigo: 'AF'
//     },
//     {
//         nombre: 'ALBANIA',
//         codigo: 'AL'
//     },
//     {
//         nombre: 'ALGERIA',
//         codigo: 'DZ'
//     },
//     {
//         nombre: 'AMERICAN SAMOA',
//         codigo: 'AS'
//     },
//     {
//         nombre: 'ANDORRA',
//         codigo: 'AD'
//     },
//     {
//         nombre: 'ANGOLA',
//         codigo: 'AO'
//     },
//     {
//         nombre: 'ANGUILLA',
//         codigo: 'AI'
//     },
//     {
//         nombre: 'ANTARCTICA',
//         codigo: 'AQ'
//     },
//     {
//         nombre: 'ANTIGUA AND BARBUDA',
//         codigo: 'AG'
//     },
//     {
//         nombre: 'ARGENTINA',
//         codigo: 'AR'
//     },
//     {
//         nombre: 'ARMENIA',
//         codigo: 'AM'
//     },
//     {
//         nombre: 'ARUBA',
//         codigo: 'AW'
//     },
//     {
//         nombre: 'AUSTRALIA',
//         codigo: 'AU'
//     },
//     {
//         nombre: 'AUSTRIA',
//         codigo: 'AT'
//     },
//     {
//         nombre: 'AZERBAIJAN',
//         codigo: 'AZ'
//     },
//     {
//         nombre: 'BAHAMAS',
//         codigo: 'BS'
//     },
//     {
//         nombre: 'BAHRAIN',
//         codigo: 'BH'
//     },
//     {
//         nombre: 'BANGLADESH',
//         codigo: 'BD'
//     },
//     {
//         nombre: 'BARBADOS',
//         codigo: 'BB'
//     },
//     {
//         nombre: 'BELARUS',
//         codigo: 'BY'
//     },
//     {
//         nombre: 'BELGIUM',
//         codigo: 'BE'
//     },
//     {
//         nombre: 'BELIZE',
//         codigo: 'BZ'
//     },
//     {
//         nombre: 'BENIN',
//         codigo: 'BJ'
//     },
//     {
//         nombre: 'BERMUDA',
//         codigo: 'BM'
//     },
//     {
//         nombre: 'BHUTAN',
//         codigo: 'BT'
//     },
//     {
//         nombre: 'BOLIVIA',
//         codigo: 'BO'
//     },
//     {
//         nombre: 'BOSNIA AND HERZEGOWINA',
//         codigo: 'BA'
//     },
//     {
//         nombre: 'BOTSWANA',
//         codigo: 'BW'
//     },
//     {
//         nombre: 'BOUVET ISLAND',
//         codigo: 'BV'
//     },
//     {
//         nombre: 'BRAZIL',
//         codigo: 'BR'
//     },
//     {
//         nombre: 'BRITISH INDIAN OCEAN TERRITORY',
//         codigo: 'IO'
//     },
//     {
//         nombre: 'BRUNEI DARUSSALAM',
//         codigo: 'BN'
//     },
//     {
//         nombre: 'BULGARIA',
//         codigo: 'BG'
//     },
//     {
//         nombre: 'BURKINA FASO',
//         codigo: 'BF'
//     },
//     {
//         nombre: 'BURUNDI',
//         codigo: 'BI'
//     },
//     {
//         nombre: 'CAMBODIA',
//         codigo: 'KH'
//     },
//     {
//         nombre: 'CAMEROON',
//         codigo: 'CM'
//     },
//     {
//         nombre: 'CANADA',
//         codigo: 'CA'
//     },
//     {
//         nombre: 'CAPE VERDE',
//         codigo: 'CV'
//     },
//     {
//         nombre: 'CAYMAN ISLANDS',
//         codigo: 'KY'
//     },
//     {
//         nombre: 'CENTRAL AFRICAN REPUBLIC',
//         codigo: 'CF'
//     },
//     {
//         nombre: 'CHAD',
//         codigo: 'TD'
//     },
//     {
//         nombre: 'CHILE',
//         codigo: 'CL'
//     },
//     {
//         nombre: 'CHINA',
//         codigo: 'CN'
//     },
//     {
//         nombre: 'CHRISTMAS ISLAND',
//         codigo: 'CX'
//     },
//     {
//         nombre: 'COCOS(KEELING) ISLANDS',
//         codigo: 'CC'
//     },
//     {
//         nombre: 'COLOMBIA',
//         codigo: 'CO'
//     },
//     {
//         nombre: 'COMOROS',
//         codigo: 'KM'
//     },
//     {
//         nombre: 'CONGO',
//         codigo: 'CD'
//     },
//     {
//         nombre: 'REPLUBLIC OF CONGO',
//         codigo: 'CG'
//     },
//     {
//         nombre: 'COOK ISLANDS',
//         codigo: 'CK'
//     },
//     {
//         nombre: 'COSTA RICA',
//         codigo: 'CR'
//     },
//     {
//         nombre: 'COTE D IVOIRE',
//         codigo:  'CI'
//     },
//     {
//         nombre: 'CROATIA',
//         codigo: 'HR'
//     },
//     {
//         nombre: 'CUBA',
//         codigo: 'CU'
//     },
//     {
//         nombre: 'CYPRUS',
//         codigo: 'CY'
//     },
//     {
//         nombre: 'CZECH REPUBLIC',
//         codigo: 'CZ'
//     },
//     {
//         nombre: 'DENMARK',
//         codigo: 'DK'
//     },
//     {
//         nombre: 'DJIBOUTI',
//         codigo: 'DJ'
//     },
//     {
//         nombre: 'DOMINICA',
//         codigo: 'DM'
//     },
//     {
//         nombre: 'DOMINICAN REPUBLIC',
//         codigo: 'DO'
//     },
//     {
//         nombre: 'ECUADOR',
//         codigo: 'EC'
//     },
//     {
//         nombre: 'EGYPT',
//         codigo: 'EG'
//     },
//     {
//         nombre: 'EL SALVADOR',
//         codigo: 'SV'
//     },
//     {
//         nombre: 'EQUATORIAL GUINEA',
//         codigo: 'GQ'
//     },
//     {
//         nombre: 'ERITREA',
//         codigo: 'ER'
//     },
//     {
//         nombre: 'ESTONIA',
//         codigo: 'EE'
//     },
//     {
//         nombre: 'ETHIOPIA',
//         codigo: 'ET'
//     },
//     {
//         nombre: 'FALKLAND ISLANDS(MALVINAS)',
//         codigo: 'FK'
//     },
//     {
//         nombre: 'FAROE ISLANDS',
//         codigo: 'FO'
//     },
//     {
//         nombre: 'FIJI',
//         codigo: 'FJ'
//     },
//     {
//         nombre: 'FINLAND',
//         codigo: 'FI'
//     },
//     {
//         nombre: 'FRANCE',
//         codigo: 'FR'
//     },
//     {
//         nombre: 'FRENCH GUIANA',
//         codigo: 'GF'
//     },
//     {
//         nombre: 'FRENCH POLYNESIA',
//         codigo: 'PF'
//     },
//     {
//         nombre: 'FRENCH SOUTHERN TERRITORIES',
//         codigo: 'TF'
//     },
//     {
//         nombre: 'GABON',
//         codigo: 'GA'
//     },
//     {
//         nombre: 'GAMBIA',
//         codigo: 'GM'
//     },
//     {
//         nombre: 'GEORGIA',
//         codigo: 'GE'
//     },
//     {
//         nombre: 'GERMANY',
//         codigo: 'DE'
//     },
//     {
//         nombre: 'GHANA',
//         codigo: 'GH'
//     },
//     {
//         nombre: 'GIBRALTAR',
//         codigo: 'GI'
//     },
//     {
//         nombre: 'GREECE',
//         codigo: 'GR'
//     },
//     {
//         nombre: 'GREENLAND',
//         codigo: 'GL'
//     },
//     {
//         nombre: 'GRENADA',
//         codigo: 'GD'
//     },
//     {
//         nombre: 'GUADELOUPE',
//         codigo: 'GP'
//     },
//     {
//         nombre: 'GUAM',
//         codigo: 'GU'
//     },
//     {
//         nombre: 'GUATEMALA',
//         codigo: 'GT'
//     },
//     {
//         nombre: 'GUINEA',
//         codigo: 'GN'
//     },
//     {
//         nombre: 'GUINEA - BISSAU',
//         codigo: 'GW'
//     },
//     {
//         nombre: 'GUYANA',
//         codigo: 'GY'
//     },
//     {
//         nombre: 'HAITI',
//         codigo: 'HT'
//     },
//     {
//         nombre: 'HEARD AND MC DONALD ISLANDS',
//         codigo: 'HM'
//     },
//     {
//         nombre: 'HONDURAS',
//         codigo: 'HN'
//     },
//     {
//         nombre: 'HONG KONG',
//         codigo: 'HK'
//     },
//     {
//         nombre: 'HUNGARY',
//         codigo: 'HU'
//     },
//     {
//         nombre: 'ICELAND',
//         codigo: 'IS'
//     },
//     {
//         nombre: 'INDIA',
//         codigo: 'IN'
//     },
//     {
//         nombre: 'INDONESIA',
//         codigo: 'ID'
//     },
//     {
//         nombre: 'IRAN(ISLAMIC REPUBLIC OF)',
//         codigo: 'IR'
//     },
//     {
//         nombre: 'IRAQ',
//         codigo: 'IQ'
//     },
//     {
//         nombre: 'IRELAND',
//         codigo: 'IE'
//     },
//     {
//         nombre: 'ISRAEL',
//         codigo: 'IL'
//     },
//     {
//         nombre: 'ITALY',
//         codigo: 'IT'
//     },
//     {
//         nombre: 'JAMAICA',
//         codigo: 'JM'
//     },
//     {
//         nombre: 'JAPAN',
//         codigo: 'JP'
//     },
//     {
//         nombre: 'JORDAN',
//         codigo: 'JO'
//     },
//     {
//         nombre: 'KAZAKHSTAN',
//         codigo: 'KZ'
//     },
//     {
//         nombre: 'KENYA',
//         codigo: 'KE'
//     },
//     {
//         nombre: 'KIRIBATI',
//         codigo: 'KI'
//     },
//     {
//         nombre: 'KOREA', 
//         codigo: 'KR'
//     },
//     {
//         nombre: 'KUWAIT',
//         codigo: 'KW'
//     },
//     {
//         nombre: 'KYRGYZSTAN',
//         codigo: 'KG'
//     },
//     {
//         nombre: 'LATVIA',
//         codigo: 'LV'
//     },
//     {
//         nombre: 'LEBANON',
//         codigo: 'LB'
//     },
//     {
//         nombre: 'LESOTHO',
//         codigo: 'LS'
//     },
//     {
//         nombre: 'LIBERIA',
//         codigo: 'LR'
//     },
//     {
//         nombre: 'LIBYAN ARAB JAMAHIRIYA',
//         codigo: 'LY'
//     },
//     {
//         nombre: 'LIECHTENSTEIN',
//         codigo: 'LI'
//     },
//     {
//         nombre: 'LITHUANIA',
//         codigo: 'LT'
//     },
//     {
//         nombre: 'LUXEMBOURG',
//         codigo: 'LU'
//     },
//     {
//         nombre: 'MACAU',
//         codigo: 'MO'
//     },
//     {
//         nombre: 'MACEDONIA',
//         codigo: 'MK'
//     },
//     {
//         nombre: 'MADAGASCAR',
//         codigo: 'MG'
//     },
//     {
//         nombre: 'MALAWI',
//         codigo: 'MW'
//     },
//     {
//         nombre: 'MALAYSIA',
//         codigo: 'MY'
//     },
//     {
//         nombre: 'MALDIVES',
//         codigo: 'MV'
//     },
//     {
//         nombre: 'MALI',
//         codigo: 'ML'
//     },
//     {
//         nombre: 'MALTA',
//         codigo: 'MT'
//     },
//     {
//         nombre: 'MARSHALL ISLANDS',
//         codigo: 'MH'
//     },
//     {
//         nombre: 'MARTINIQUE',
//         codigo: 'MQ'
//     },
//     {
//         nombre: 'MAURITANIA',
//         codigo: 'MR'
//     },
//     {
//         nombre: 'MAURITIUS',
//         codigo: 'MU'
//     },
//     {
//         nombre: 'MAYOTTE',
//         codigo: 'YT'
//     },
//     {
//         nombre: 'MEXICO',
//         codigo: 'MX'
//     },
//     {
//         nombre: 'MICRONESIA',
//         codigo: 'FM'
//     },
//     {
//         nombre: 'MOLDOVA',
//         codigo: 'MD'
//     },
//     {
//         nombre: 'MONACO',
//         codigo: 'MC'
//     },
//     {
//         nombre: 'MONGOLIA',
//         codigo: 'MN'
//     },
//     {
//         nombre: 'MONTSERRAT',
//         codigo: 'MS'
//     },
//     {
//         nombre: 'MOROCCO',
//         codigo: 'MA'
//     },
//     {
//         nombre: 'MOZAMBIQUE',
//         codigo: 'MZ'
//     },
//     {
//         nombre: 'MYANMAR',
//         codigo: 'MM'
//     },
//     {
//         nombre: 'NAMIBIA',
//         codigo: 'NA'
//     },
//     {
//         nombre: 'NAURU',
//         codigo: 'NR'
//     },
//     {
//         nombre: 'NEPAL',
//         codigo: 'NP'
//     },
//     {
//         nombre: 'NETHERLANDS',
//         codigo: 'NL'
//     },
//     {
//         nombre: 'NETHERLANDS ANTILLES',
//         codigo: 'AN'
//     },
//     {
//         nombre: 'NEW CALEDONIA',
//         codigo: 'NC'
//     },
//     {
//         nombre: 'NEW ZEALAND',
//         codigo: 'NZ'
//     },
//     {
//         nombre: 'NICARAGUA',
//         codigo: 'NI'
//     },
//     {
//         nombre: 'NIGER',
//         codigo: 'NE'
//     },
//     {
//         nombre: 'NIGERIA',
//         codigo: 'NG'
//     },
//     {
//         nombre: 'NIUE',
//         codigo: 'NU'
//     },
//     {
//         nombre: 'NORFOLK ISLAND',
//         codigo: 'NF'
//     },
//     {
//         nombre: 'NORTHERN MARIANA ISLANDS',
//         codigo: 'MP'
//     },
//     {
//         nombre: 'NORWAY',
//         codigo: 'NO'
//     },
//     {
//         nombre: 'OMAN',
//         codigo: 'OM'
//     },
//     {
//         nombre: 'PAKISTAN',
//         codigo: 'PK'
//     },
//     {
//         nombre: 'PALAU',
//         codigo: 'PW'
//     },
//     {
//         nombre: 'PALESTINIAN TERRITORY',
//         codigo: 'PS'
//     },
//     {
//         nombre: 'PANAMA',
//         codigo: 'PA'
//     },
//     {
//         nombre: 'PAPUA NEW GUINEA',
//         codigo: 'PG'
//     },
//     {
//         nombre: 'PARAGUAY',
//         codigo: 'PY'
//     },
//     {
//         nombre: 'PERU',
//         codigo: 'PE'
//     },
//     {
//         nombre: 'PHILIPPINES',
//         codigo: 'PH'
//     },
//     {
//         nombre: 'PITCAIRN',
//         codigo: 'PN'
//     },
//     {
//         nombre: 'POLAND',
//         codigo: 'PL'
//     },
//     {
//         nombre: 'PORTUGAL',
//         codigo: 'PT'
//     },
//     {
//         nombre: 'PUERTO RICO',
//         codigo: 'PR'
//     },
//     {
//         nombre: 'QATAR',
//         codigo: 'QA'
//     },
//     {
//         nombre: 'REUNION',
//         codigo: 'RE'
//     },
//     {
//         nombre: 'ROMANIA',
//         codigo: 'RO'
//     },
//     {
//         nombre: 'RUSSIAN FEDERATION',
//         codigo: 'RU'
//     },
//     {
//         nombre: 'RWANDA',
//         codigo: 'RW'
//     },
//     {
//         nombre: 'SAINT HELENA',
//         codigo: 'SH'
//     },
//     {
//         nombre: 'SAINT KITTS AND NEVIS',
//         codigo: 'KN'
//     },
//     {
//         nombre: 'SAINT LUCIA',
//         codigo: 'LC'
//     },
//     {
//         nombre: 'SAINT PIERRE AND MIQUELON',
//         codigo: 'PM'
//     },
//     {
//         nombre: 'SAINT VINCENT AND THE GRENADINES',
//         codigo: 'VC'
//     },
//     {
//         nombre: 'SAMOA',
//         codigo: 'WS'
//     },
//     {
//         nombre: 'SAN MARINO',
//         codigo: 'SM'
//     },
//     {
//         nombre: 'SAO TOME AND PRINCIPE',
//         codigo: 'ST'
//     },
//     {
//         nombre: 'SAUDI ARABIA',
//         codigo: 'SA'
//     },
//     {
//         nombre: 'SENEGAL',
//         codigo: 'SN'
//     },
//     {
//         nombre: 'SERBIA',
//         codigo: 'CS'
//     },
//     {
//         nombre: 'SEYCHELLES',
//         codigo: 'SC'
//     },
//     {
//         nombre: 'SIERRA LEONE',
//         codigo: 'SL'
//     },
//     {
//         nombre: 'SINGAPORE',
//         codigo: 'SG'
//     },
//     {
//         nombre: 'SLOVAKIA',
//         codigo: 'SK'
//     },
//     {
//         nombre: 'SLOVENIA',
//         codigo: 'SI'
//     },
//     {
//         nombre: 'SOLOMON ISLANDS',
//         codigo: 'SB'
//     },
//     {
//         nombre: 'SOMALIA',
//         codigo: 'SO'
//     },
//     {
//         nombre: 'SOUTH AFRICA',
//         codigo: 'ZA'
//     },
//     {
//         nombre: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS',
//         codigo: 'GS'
//     },
//     {
//         nombre: 'SPAIN',
//         codigo: 'ES'
//     },
//     {
//         nombre: 'SRI LANKA',
//         codigo: 'LK'
//     },
//     {
//         nombre: 'SUDAN',
//         codigo: 'SD'
//     },
//     {
//         nombre: 'SURINAME',
//         codigo: 'SR'
//     },
//     {
//         nombre: 'SVALBARD AND JAN MAYEN ISLANDS',
//         codigo: 'SJ'
//     },
//     {
//         nombre: 'SWAZILAND',
//         codigo: 'SZ'
//     },
//     {
//         nombre: 'SWEDEN',
//         codigo: 'SE'
//     },
//     {
//         nombre: 'SWITZERLAND',
//         codigo: 'CH'
//     },
//     {
//         nombre: 'SYRIAN ARAB REPUBLIC',
//         codigo: 'SY'
//     },
//     {
//         nombre: 'TAIWAN',
//         codigo: 'TW'
//     },
//     {
//         nombre: 'TAJIKISTAN',
//         codigo: 'TJ'
//     },
//     {
//         nombre: 'TANZANIA',
//         codigo: 'TZ'
//     },
//     {
//         nombre: 'THAILAND',
//         codigo: 'TH'
//     },
//     {
//         nombre: 'TIMOR - LESTE',
//         codigo: 'TL'
//     },
//     {
//         nombre: 'TOGO',
//         codigo: 'TG'
//     },
//     {
//         nombre: 'TOKELAU',
//         codigo: 'TK'
//     },
//     {
//         nombre: 'TONGA',
//         codigo: 'TO'
//     },
//     {
//         nombre: 'TRINIDAD AND TOBAGO',
//         codigo: 'TT'
//     },
//     {
//         nombre: 'TUNISIA',
//         codigo: 'TN'
//     },
//     {
//         nombre: 'TURKEY',
//         codigo: 'TR'
//     },
//     {
//         nombre: 'TURKMENISTAN',
//         codigo: 'TM'
//     },
//     {
//         nombre: 'TURKS AND CAICOS ISLANDS',
//         codigo: 'TC'
//     },
//     {
//         nombre: 'TUVALU',
//         codigo: 'TV'
//     },
//     {
//         nombre: 'UGANDA',
//         codigo: 'UG'
//     },
//     {
//         nombre: 'UKRAINE',
//         codigo: 'UA'
//     },
//     {
//         nombre: 'UNITED ARAB EMIRATES',
//         codigo: 'AE'
//     },
//     {
//         nombre: 'UNITED KINGDOM',
//         codigo: 'GB'
//     },
//     {
//         nombre: 'UNITED STATES',
//         codigo: 'US'
//     },
//     {
//         nombre: 'UNITED STATES MINOR OUTLYING ISLANDS',
//         codigo: 'UM'
//     },
//     {
//         nombre: 'URUGUAY',
//         codigo: 'UY'
//     },
//     {
//         nombre: 'UZBEKISTAN',
//         codigo: 'UZ'
//     },
//     {
//         nombre: 'VANUATU',
//         codigo: 'VU'
//     },
//     {
//         nombre: 'VATICAN CITY STATE(HOLY SEE)',
//         codigo: 'VA'
//     },
//     {
//         nombre: 'VENEZUELA',
//         codigo: 'VE'
//     },
//     {
//         nombre: 'VIET NAM',
//         codigo: 'VN'
//     },
//     {
//         nombre: 'VIRGIN ISLANDS(BRITISH)',
//         codigo: 'VG'
//     },
//     {
//         nombre: 'VIRGIN ISLANDS(U.S.)',
//         codigo: 'VI'
//     },
//     {
//         nombre: 'WALLIS AND FUTUNA ISLANDS',
//         codigo: 'WF'
//     },
//     {
//         nombre: 'WESTERN SAHARA',
//         codigo: 'EH'
//     },
//     {
//         nombre: 'YEMEN',
//         codigo: 'YE'
//     },
//     {
//         nombre: 'ZAMBIA',
//         codigo: 'ZM'
//     },
//     {
//         nombre: 'ZIMBABWE',
//         codigo: 'ZW'
//     }
// ]

export const codigoPaises = [
    {
        nombre: 'ISLAS ALAND    ',
        codigo: 'AX'
    },
    {
        nombre: 'AFGANISTÁN',
        codigo: 'AF'
    },
    {
        nombre: 'ALBANIA',
        codigo: 'AL'
    },
    {
        nombre: 'ARGELIA',
        codigo: 'DZ'
    },
    {
        nombre: 'SAMOA AMERICANA',
        codigo: 'AS'
    },
    {
        nombre: 'ANDORRA',
        codigo: 'AD'
    },
    {
        nombre: 'ANGOLA',
        codigo: 'AO'
    },
    {
        nombre: 'ANGUILA',
        codigo: 'AI'
    },
    {
        nombre: 'ANTÁRTIDA',
        codigo: 'AQ'
    },
    {
        nombre: 'ANTIGUA Y BARBUDA',
        codigo: 'AG'
    },
    {
        nombre: 'ARGENTINA',
        codigo: 'AR'
    },
    {
        nombre: 'ARMENIA',
        codigo: 'AM'
    },
    {
        nombre: 'ARUBA',
        codigo: 'AW'
    },
    {
        nombre: 'AUSTRALIA',
        codigo: 'AU'
    },
    {
        nombre: 'AUSTRIA',
        codigo: 'AT'
    },
    {
        nombre: 'AZERBAIYAN',
        codigo: 'AZ'
    },
    {
        nombre: 'BAHAMAS',
        codigo: 'BS'
    },
    {
        nombre: 'BAREIN',
        codigo: 'BH'
    },
    {
        nombre: 'BANGLADES',
        codigo: 'BD'
    },
    {
        nombre: 'BARBADOS',
        codigo: 'BB'
    },
    {
        nombre: 'BIELORRUSIA',
        codigo: 'BY'
    },
    {
        nombre: 'BELGICA',
        codigo: 'BE'
    },
    {
        nombre: 'BELICE',
        codigo: 'BZ'
    },
    {
        nombre: 'BENIN',
        codigo: 'BJ'
    },
    {
        nombre: 'BERMUDAS',
        codigo: 'BM'
    },
    {
        nombre: 'BUTAN',
        codigo: 'BT'
    },
    {
        nombre: 'BOLIVIA',
        codigo: 'BO'
    },
    {
        nombre: 'BOSNIA Y HERZEGOVINA',
        codigo: 'BA'
    },
    {
        nombre: 'BOTSWANA',
        codigo: 'BW'
    },
    {
        nombre: 'ISLA BOUVET',
        codigo: 'BV'
    },
    {
        nombre: 'BRASIL',
        codigo: 'BR'
    },
    {
        nombre: 'TERRITORIO BRITANICO DEL OCEANO INDICO',
        codigo: 'IO'
    },
    {
        nombre: 'BRUNEI DARUSSALAM',
        codigo: 'BN'
    },
    {
        nombre: 'BULGARIA',
        codigo: 'BG'
    },
    {
        nombre: 'BURKINA FASO',
        codigo: 'BF'
    },
    {
        nombre: 'BURUNDI',
        codigo: 'BI'
    },
    {
        nombre: 'CAMBOYA',
        codigo: 'KH'
    },
    {
        nombre: 'CAMERUN',
        codigo: 'CM'
    },
    {
        nombre: 'CANADA',
        codigo: 'CA'
    },
    {
        nombre: 'CABO VERDE',
        codigo: 'CV'
    },
    {
        nombre: 'ISLAS CAIMAN',
        codigo: 'KY'
    },
    {
        nombre: 'REPUBLICA CENTROAFRICANA',
        codigo: 'CF'
    },
    {
        nombre: 'CHAD',
        codigo: 'TD'
    },
    {
        nombre: 'CHILE',
        codigo: 'CL'
    },
    {
        nombre: 'CHINA',
        codigo: 'CN'
    },
    {
        nombre: 'ISLA DE NAVIDAD',
        codigo: 'CX'
    },
    {
        nombre: 'COCOS(KEELING) ISLAS',
        codigo: 'CC'
    },
    {
        nombre: 'COLOMBIA',
        codigo: 'CO'
    },
    {
        nombre: 'COMORAS',
        codigo: 'KM'
    },
    {
        nombre: 'CONGO',
        codigo: 'CD'
    },
    {
        nombre: 'REPUBLICA DEL CONGO',
        codigo: 'CG'
    },
    {
        nombre: 'ISLAS COOK',
        codigo: 'CK'
    },
    {
        nombre: 'COSTA RICA',
        codigo: 'CR'
    },
    {
        nombre: 'COSTA DE MARFIL',
        codigo:  'CI'
    },
    {
        nombre: 'CROACIA',
        codigo: 'HR'
    },
    {
        nombre: 'CUBA',
        codigo: 'CU'
    },
    {
        nombre: 'CHIPRE',
        codigo: 'CY'
    },
    {
        nombre: 'REPUBLICA CHECA',
        codigo: 'CZ'
    },
    {
        nombre: 'DINAMARCA',
        codigo: 'DK'
    },
    {
        nombre: 'DJIBOUTI',
        codigo: 'DJ'
    },
    {
        nombre: 'DOMINICA',
        codigo: 'DM'
    },
    {
        nombre: 'REPUBLICA DOMINICANA',
        codigo: 'DO'
    },
    {
        nombre: 'ECUADOR',
        codigo: 'EC'
    },
    {
        nombre: 'EGIPTO',
        codigo: 'EG'
    },
    {
        nombre: 'EL SALVADOR',
        codigo: 'SV'
    },
    {
        nombre: 'GUINEA ECUATORIAL',
        codigo: 'GQ'
    },
    {
        nombre: 'ERITREA',
        codigo: 'ER'
    },
    {
        nombre: 'ESTONIA',
        codigo: 'EE'
    },
    {
        nombre: 'ETHIOPIA',
        codigo: 'ET'
    },
    {
        nombre: 'ISLAS MALVINAS',
        codigo: 'FK'
    },
    {
        nombre: 'ISLAS FEROE',
        codigo: 'FO'
    },
    {
        nombre: 'FIYI',
        codigo: 'FJ'
    },
    {
        nombre: 'FINLANDIA',
        codigo: 'FI'
    },
    {
        nombre: 'FRANCIA',
        codigo: 'FR'
    },
    {
        nombre: 'GUAYANA FRANCESA',
        codigo: 'GF'
    },
    {
        nombre: 'POLINESIA FRANCESA',
        codigo: 'PF'
    },
    {
        nombre: 'TERRITORIOS FRANCESES DEL SUR',
        codigo: 'TF'
    },
    {
        nombre: 'GABON',
        codigo: 'GA'
    },
    {
        nombre: 'GAMBIA',
        codigo: 'GM'
    },
    {
        nombre: 'GEORGIA',
        codigo: 'GE'
    },
    {
        nombre: 'ALEMANIA',
        codigo: 'DE'
    },
    {
        nombre: 'GHANA',
        codigo: 'GH'
    },
    {
        nombre: 'GIBRALTAR',
        codigo: 'GI'
    },
    {
        nombre: 'GRECIA',
        codigo: 'GR'
    },
    {
        nombre: 'GROENLANDIA',
        codigo: 'GL'
    },
    {
        nombre: 'GRANADA',
        codigo: 'GD'
    },
    {
        nombre: 'GUADALUPE',
        codigo: 'GP'
    },
    {
        nombre: 'GUAM',
        codigo: 'GU'
    },
    {
        nombre: 'GUATEMALA',
        codigo: 'GT'
    },
    {
        nombre: 'GUINEA',
        codigo: 'GN'
    },
    {
        nombre: 'GUINEA - BISAU',
        codigo: 'GW'
    },
    {
        nombre: 'GUYANA',
        codigo: 'GY'
    },
    {
        nombre: 'HAITI',
        codigo: 'HT'
    },
    {
        nombre: 'ISLAS HEARD Y MCDONALD',
        codigo: 'HM'
    },
    {
        nombre: 'HONDURAS',
        codigo: 'HN'
    },
    {
        nombre: 'HONG KONG',
        codigo: 'HK'
    },
    {
        nombre: 'HUNGRIA',
        codigo: 'HU'
    },
    {
        nombre: 'ISLANDIA',
        codigo: 'IS'
    },
    {
        nombre: 'INDIA',
        codigo: 'IN'
    },
    {
        nombre: 'INDONESIA',
        codigo: 'ID'
    },
    {
        nombre: 'IRAN(REPUBLICA ISLAMICA)',
        codigo: 'IR'
    },
    {
        nombre: 'IRAK',
        codigo: 'IQ'
    },
    {
        nombre: 'IRLANDA',
        codigo: 'IE'
    },
    {
        nombre: 'ISRAEL',
        codigo: 'IL'
    },
    {
        nombre: 'ITALIA',
        codigo: 'IT'
    },
    {
        nombre: 'JAMAICA',
        codigo: 'JM'
    },
    {
        nombre: 'JAPON',
        codigo: 'JP'
    },
    {
        nombre: 'JORDANIA',
        codigo: 'JO'
    },
    {
        nombre: 'KAZAJISTAN',
        codigo: 'KZ'
    },
    {
        nombre: 'KENIA',
        codigo: 'KE'
    },
    {
        nombre: 'KIRIBATI',
        codigo: 'KI'
    },
    {
        nombre: 'KOREA', 
        codigo: 'KR'
    },
    {
        nombre: 'KUWAIT',
        codigo: 'KW'
    },
    {
        nombre: 'KIRGUISTAN',
        codigo: 'KG'
    },
    {
        nombre: 'LETONIA',
        codigo: 'LV'
    },
    {
        nombre: 'LIBANO',
        codigo: 'LB'
    },
    {
        nombre: 'LESOTO',
        codigo: 'LS'
    },
    {
        nombre: 'LIBERIA',
        codigo: 'LR'
    },
    {
        nombre: 'ARABE LIBIO JAMAHIRIYA',
        codigo: 'LY'
    },
    {
        nombre: 'LIECHTENSTEIN',
        codigo: 'LI'
    },
    {
        nombre: 'LITUANIA',
        codigo: 'LT'
    },
    {
        nombre: 'LUXEMBURGO',
        codigo: 'LU'
    },
    {
        nombre: 'MACAO',
        codigo: 'MO'
    },
    {
        nombre: 'MACEDONIA',
        codigo: 'MK'
    },
    {
        nombre: 'MADAGASCAR',
        codigo: 'MG'
    },
    {
        nombre: 'MALAWI',
        codigo: 'MW'
    },
    {
        nombre: 'MALASIA',
        codigo: 'MY'
    },
    {
        nombre: 'MALDIVAS',
        codigo: 'MV'
    },
    {
        nombre: 'MALI',
        codigo: 'ML'
    },
    {
        nombre: 'MALTA',
        codigo: 'MT'
    },
    {
        nombre: 'ISLAS MARSHALL',
        codigo: 'MH'
    },
    {
        nombre: 'MARTINICA',
        codigo: 'MQ'
    },
    {
        nombre: 'MAURITANIA',
        codigo: 'MR'
    },
    {
        nombre: 'MAURICIO',
        codigo: 'MU'
    },
    {
        nombre: 'MAYOTTE',
        codigo: 'YT'
    },
    {
        nombre: 'MEXICO',
        codigo: 'MX'
    },
    {
        nombre: 'MICRONESIA',
        codigo: 'FM'
    },
    {
        nombre: 'MOLDAVIA',
        codigo: 'MD'
    },
    {
        nombre: 'MONACO',
        codigo: 'MC'
    },
    {
        nombre: 'MONGOLIA',
        codigo: 'MN'
    },
    {
        nombre: 'MONTSERRAT',
        codigo: 'MS'
    },
    {
        nombre: 'MARRUECOS',
        codigo: 'MA'
    },
    {
        nombre: 'MOZAMBIQUE',
        codigo: 'MZ'
    },
    {
        nombre: 'MYANMAR',
        codigo: 'MM'
    },
    {
        nombre: 'NAMIBIA',
        codigo: 'NA'
    },
    {
        nombre: 'NAURU',
        codigo: 'NR'
    },
    {
        nombre: 'NEPAL',
        codigo: 'NP'
    },
    {
        nombre: 'PAISES BAJOS',
        codigo: 'NL'
    },
    {
        nombre: 'ANTILLAS HOLANDESAS',
        codigo: 'AN'
    },
    {
        nombre: 'NUEVA CALEDONIA',
        codigo: 'NC'
    },
    {
        nombre: 'NUEVA ZELANDA',
        codigo: 'NZ'
    },
    {
        nombre: 'NICARAGUA',
        codigo: 'NI'
    },
    {
        nombre: 'NIGER',
        codigo: 'NE'
    },
    {
        nombre: 'NIGERIA',
        codigo: 'NG'
    },
    {
        nombre: 'NIUE',
        codigo: 'NU'
    },
    {
        nombre: 'ISLA NORFOLK',
        codigo: 'NF'
    },
    {
        nombre: 'ISLAS MARIANAS DEL NORTE',
        codigo: 'MP'
    },
    {
        nombre: 'NORUEGA',
        codigo: 'NO'
    },
    {
        nombre: 'OMAN',
        codigo: 'OM'
    },
    {
        nombre: 'PAKISTAN',
        codigo: 'PK'
    },
    {
        nombre: 'PALAU',
        codigo: 'PW'
    },
    {
        nombre: 'TERRITORIOS PALESTINOS',
        codigo: 'PS'
    },
    {
        nombre: 'PANAMA',
        codigo: 'PA'
    },
    {
        nombre: 'PAPUA NUEVA GUINEA',
        codigo: 'PG'
    },
    {
        nombre: 'PARAGUAY',
        codigo: 'PY'
    },
    {
        nombre: 'PERU',
        codigo: 'PE'
    },
    {
        nombre: 'FILIPINAS',
        codigo: 'PH'
    },
    {
        nombre: 'PITCAIRN',
        codigo: 'PN'
    },
    {
        nombre: 'POLONIA',
        codigo: 'PL'
    },
    {
        nombre: 'PORTUGAL',
        codigo: 'PT'
    },
    {
        nombre: 'PUERTO RICO',
        codigo: 'PR'
    },
    {
        nombre: 'Catar',
        codigo: 'QA'
    },
    {
        nombre: 'REUNION',
        codigo: 'RE'
    },
    {
        nombre: 'RUMANIA',
        codigo: 'RO'
    },
    {
        nombre: 'FEDERACION RUSA',
        codigo: 'RU'
    },
    {
        nombre: 'RUANDA',
        codigo: 'RW'
    },
    {
        nombre: 'SANTA ELENA',
        codigo: 'SH'
    },
    {
        nombre: 'SAN CRISTOBAL Y NIEVES',
        codigo: 'KN'
    },
    {
        nombre: 'SANTA LUCIA',
        codigo: 'LC'
    },
    {
        nombre: 'SAN PEDRO Y MIQUELON',
        codigo: 'PM'
    },
    {
        nombre: 'SAN VICENTE Y LAS GRANADINAS',
        codigo: 'VC'
    },
    {
        nombre: 'SAMOA',
        codigo: 'WS'
    },
    {
        nombre: 'SAN MARINO',
        codigo: 'SM'
    },
    {
        nombre: 'SANTO TOME Y PRINCIPE',
        codigo: 'ST'
    },
    {
        nombre: 'ARABIA SAUDITA',
        codigo: 'SA'
    },
    {
        nombre: 'SENEGAL',
        codigo: 'SN'
    },
    {
        nombre: 'SERBIA',
        codigo: 'CS'
    },
    {
        nombre: 'SEYCHELLES',
        codigo: 'SC'
    },
    {
        nombre: 'SIERRA LEONA',
        codigo: 'SL'
    },
    {
        nombre: 'SINGAPUR',
        codigo: 'SG'
    },
    {
        nombre: 'ESLOVAQUIA',
        codigo: 'SK'
    },
    {
        nombre: 'ESLOVENIA',
        codigo: 'SI'
    },
    {
        nombre: 'ISLAS SALOMÓN',
        codigo: 'SB'
    },
    {
        nombre: 'SOMALIA',
        codigo: 'SO'
    },
    {
        nombre: 'SUDAFRICA',
        codigo: 'ZA'
    },
    {
        nombre: 'GEORGIA DEL SUR Y LAS ISLAS SANDWICH DEL SUR',
        codigo: 'GS'
    },
    {
        nombre: 'ESPAÑA',
        codigo: 'ES'
    },
    {
        nombre: 'SRI LANKA',
        codigo: 'LK'
    },
    {
        nombre: 'SUDAN',
        codigo: 'SD'
    },
    {
        nombre: 'SURINAME',
        codigo: 'SR'
    },
    {
        nombre: 'ISLAS SVALBARD Y JAN MAYEN',
        codigo: 'SJ'
    },
    {
        nombre: 'SUAZILANDIA',
        codigo: 'SZ'
    },
    {
        nombre: 'SUECIA',
        codigo: 'SE'
    },
    {
        nombre: 'SUIZA',
        codigo: 'CH'
    },
    {
        nombre: 'REPUBLICA ARABE SIRIA',
        codigo: 'SY'
    },
    {
        nombre: 'TAIWAN',
        codigo: 'TW'
    },
    {
        nombre: 'TAYIKISTAN',
        codigo: 'TJ'
    },
    {
        nombre: 'TANZANIA',
        codigo: 'TZ'
    },
    {
        nombre: 'TAILANDIA',
        codigo: 'TH'
    },
    {
        nombre: 'TIMOR - LESTE',
        codigo: 'TL'
    },
    {
        nombre: 'TOGO',
        codigo: 'TG'
    },
    {
        nombre: 'TOKELAU',
        codigo: 'TK'
    },
    {
        nombre: 'TONGA',
        codigo: 'TO'
    },
    {
        nombre: 'TRINIDAD AND TOBAGO',
        codigo: 'TT'
    },
    {
        nombre: 'TUNEZ',
        codigo: 'TN'
    },
    {
        nombre: 'TURQUIA',
        codigo: 'TR'
    },
    {
        nombre: 'TURKMENISTAN',
        codigo: 'TM'
    },
    {
        nombre: 'ISLAS TURCAS Y CAICOS',
        codigo: 'TC'
    },
    {
        nombre: 'TUVALU',
        codigo: 'TV'
    },
    {
        nombre: 'UGANDA',
        codigo: 'UG'
    },
    {
        nombre: 'UCRANIA',
        codigo: 'UA'
    },
    {
        nombre: 'EMIRATOS ÁRABES UNIDOS',
        codigo: 'AE'
    },
    {
        nombre: 'REINO UNIDO',
        codigo: 'GB'
    },
    {
        nombre: 'ESTADOS UNIDOS',
        codigo: 'US'
    },
    {
        nombre: 'ISLAS EXTERIORES MENORES DE ESTADOS UNIDOS',
        codigo: 'UM'
    },
    {
        nombre: 'URUGUAY',
        codigo: 'UY'
    },
    {
        nombre: 'UZBEKISTAN',
        codigo: 'UZ'
    },
    {
        nombre: 'VANUATU',
        codigo: 'VU'
    },
    {
        nombre: 'ESTADO DE LA CIUDAD DEL VATICANO(SANTA SEDE)',
        codigo: 'VA'
    },
    {
        nombre: 'VENEZUELA',
        codigo: 'VE'
    },
    {
        nombre: 'VIETNAM',
        codigo: 'VN'
    },
    {
        nombre: 'ISLAS VIRGENES(BRITANICO)',
        codigo: 'VG'
    },
    {
        nombre: 'ISLAS VIRGENES(ESTADOS UNIDOS)',
        codigo: 'VI'
    },
    {
        nombre: 'ISLAS WALLIS Y FUTUNA',
        codigo: 'WF'
    },
    {
        nombre: 'SAHARA OCCIDENTAL',
        codigo: 'EH'
    },
    {
        nombre: 'YEMEN',
        codigo: 'YE'
    },
    {
        nombre: 'ZAMBIA',
        codigo: 'ZM'
    },
    {
        nombre: 'ZIMBABUE',
        codigo: 'ZW'
    }
]
        

